import { Answers, SurveyPerson } from "types";
import dayjs from "dayjs";
import uniqWith from "lodash/uniqWith";
import isEqual from "lodash/isEqual";

export const templateChildren = {
  name: "b6494e87-8f68-4a03-a9c8-82e42e612e92",
  dateBirth: "ca20eddb-71f7-4287-9bb1-f11e7ab92c12",
  livingPlace: "034271f1-e2e2-4aa3-a698-383977f5cc54",
  gender: "488b58f7-59ce-4237-8691-40c99cc12206",
  takeCare: "2d5468a1-d937-4139-bda5-a80da9e31226",
  hasDisability: "6f65647b-8923-404c-b1d1-d7b6eaac71c5",
  disabilityType: "b7351d2a-de2a-4d73-b411-cae46915dec1",
  isContributor: "54935073-f7fd-498d-85cc-0cd80349c9fd",
  isDependent: "f8f2f738-70d4-4241-9c66-33de707dac41",
  isBenefit: "14fa7d4f-6436-4c85-a70a-cc0c36522d80",
  educationLevel: "38f0d3c5-935e-4cc0-8fcd-191cbf80d98e",
  isStudent: "ba3587c6-b3b4-4148-8c7a-8385ca511f93",
  transportation: "f10858af-61e7-4e8f-86a9-4b046a3c2d2a",
  estates: "cd796fc6-8164-4359-bc1e-02e666640907",
  hasActivities: "0bf0fb9f-6e59-4bae-b644-420accbb5671",
  activity: "3c858265-5760-430f-bfe1-1f2f48ccd415",
};

export const templateChildrenModel = {
  "b6494e87-8f68-4a03-a9c8-82e42e612e92": "",
  "ca20eddb-71f7-4287-9bb1-f11e7ab92c12": "",
  "488b58f7-59ce-4237-8691-40c99cc12206": "",
  "034271f1-e2e2-4aa3-a698-383977f5cc54": "",
  "2d5468a1-d937-4139-bda5-a80da9e31226": "",
  "6f65647b-8923-404c-b1d1-d7b6eaac71c5": "",
  "b7351d2a-de2a-4d73-b411-cae46915dec1": "",
  "54935073-f7fd-498d-85cc-0cd80349c9fd": "",
  "f8f2f738-70d4-4241-9c66-33de707dac41": "",
  "14fa7d4f-6436-4c85-a70a-cc0c36522d80": "",
  "38f0d3c5-935e-4cc0-8fcd-191cbf80d98e": "",
  "ba3587c6-b3b4-4148-8c7a-8385ca511f93": "",
  "f10858af-61e7-4e8f-86a9-4b046a3c2d2a": [],
  "cd796fc6-8164-4359-bc1e-02e666640907": [],
  "0bf0fb9f-6e59-4bae-b644-420accbb5671": "",
  "3c858265-5760-430f-bfe1-1f2f48ccd415": "",
};

export const templatePerson = {
  name: "8ec35cdc-1ae8-4bc2-a9c7-37e73da8a953",
  gender: "f79e4215-d3df-4f40-b349-8fbb54c2bf47",
  parentage: "acde57e7-a501-4ab8-80ad-37d3997966c6",
  ageRange: "b21713a3-6887-4e33-bd39-006ecefa82c2",
  isContributor: "5969d844-5ad1-40f7-8aa0-aae1f1b50bd0",
  isDependent: "c93e8a1e-6a34-4acb-a695-f21d022641ff",
  isBenefit: "d794fc8e-21b6-4047-b830-0438e3d0f79c",
  hasDisability: "66f1f969-4229-4e07-8fb2-1329a944a27a",
  disabilityType: "60cf024c-a999-4366-884f-f2fd296053d2",
};

export const templatePersonsModel = {
  "8ec35cdc-1ae8-4bc2-a9c7-37e73da8a953": "",
  "f79e4215-d3df-4f40-b349-8fbb54c2bf47": "",
  "acde57e7-a501-4ab8-80ad-37d3997966c6": "",
  "b21713a3-6887-4e33-bd39-006ecefa82c2": "",
  "5969d844-5ad1-40f7-8aa0-aae1f1b50bd0": "",
  "c93e8a1e-6a34-4acb-a695-f21d022641ff": "",
  "d794fc8e-21b6-4047-b830-0438e3d0f79c": "",
  "66f1f969-4229-4e07-8fb2-1329a944a27a": "",
  "60cf024c-a999-4366-884f-f2fd296053d2": "",
};

export const questionIds: any = {
  step1: {
    identificationType: "9ea527da-c339-4a38-a71e-5b26f3353d62",
    documentNumber: "6520de3a-bb64-4531-85ec-d1eb0dba3e2c",
    name: "5a2323ae-1593-4818-a9a2-6cb3e8b5768e",
    lastName: "edaba760-6ad4-4ecb-9265-6a0412bd059b",
  },
  step2: {
    gender: "16d8bc59-a672-445d-b295-2ef0d27a2cc4",
    birthCountry: "ed08be0d-0ed2-4fbe-81a4-f216e5531363",
    birthState: "06849d6f-5b94-48e0-a7ba-c6b6e7c58482",
    birthCity: "02fa9656-a4bc-4c9c-a105-f91db3b7c56f",
    birthDate: "671b736f-c4c6-4c96-97d0-e99e4410f596",
    maritalStatus: "9136deb4-6546-42ab-8c79-a30ba990b2d1",
    socialGroups: "a1b438a2-82da-4862-8c71-a740bfcca20b",
    sisben: "ce3b727c-7a51-45a4-baa5-32ff306bd9c6",
    sisbenCategory: "f76358c1-b3f4-4f96-8d17-dd9e6bf0dfcc",
  },
  step3: {
    branch: "ae8dd41f-b5d9-4426-be0f-2b8925282f4c",
    jobTitle: "62988f25-2c7a-43e6-a5f6-d684b3d525fa",
    compensationCompany: "18e5e6d6-db79-4363-9f42-b4a63fa092d4",
    jubilation: "585cee00-8ef0-4ef5-9b0f-14ff1766a761",
    layoff: "7d177d6d-43a3-4208-8ff0-ebfe48e27cdc",
    eps: "fb479282-935d-4446-8f28-392141caf099",
  },
  step4: {
    cellPhoneNumber: "64f86fb5-3299-4e9f-9ac0-ef5493cc3924",
    cellPhoneCompany: "57f12fd7-bbee-4012-8b7a-e52897a63dc2",
    email: "43c0402b-01d8-4d79-a63e-1959b5f6b415",
    hasCellPhone: "ad2e14db-9a1a-4dc6-ae51-bb4e8380a6a1",
    emergencyContactName: "2eac3331-aaad-4fb8-a0bb-65b01c39fe3a",
    relationshipEmergencyContact: "94edc685-26f3-400d-8abe-4598e4baee8b",
    emergencyContactPhoneNumber: "72649286-f479-4f06-b7f8-54293f72242b",
  },
  step5: {
    transportation: "1e772b1a-1280-45ea-8c63-90f02310d9ed",
    transportationTime: "baab5858-0653-45d8-b8ac-4c4071f63bae",
    emergencyCorps: "d91377f1-7c0e-43fc-aab7-1f5ba553bbae",
    hasEmploymentFund: "e2d47998-4e83-4c36-b8df-4051c012c5a7",
  },
  step6: {
    placeCountry: "0dafd890-eb50-46f8-b00d-95b58e8161ef",
    placeState: "92b3467b-90de-4da1-8185-146ae825cbae",
    placeCity: "95455ba2-b742-450a-8e8c-927695b3ab65",
    neighborhood: "2e2235ec-8582-411e-859d-5b48f48ffbd3",
    address: "8b1166c3-58c6-445b-b922-b5efca57c6e9",
    dwellTime: "cf51c436-c275-4ae3-935f-6ff9b8a4e5a9",
    houseLocation: "9ade7554-150a-4701-8e5f-b0fe96665d48",
    category: "c4e2869b-3aa7-472c-96b2-b8ae1076f58e",
    houseType: "d09102bb-8cec-4f10-a7dc-ea689b23416d",
    houseTenure: "591c06cd-f58d-4cba-8c4b-2e38f1945033",
  },
  step7: {
    houseContition: "c8db2503-2eff-4c25-b31c-1befc5c754ff",
    houseStatus: "194f4422-ea28-4559-8f34-ba22fc8c0bc1",
    rooms: "edb582e8-eabe-41a5-8737-de4be4aeda56",
    houseServices: "877f84da-5b82-41e6-ab93-b559b1b17f7f",
  },
  step8: {
    properties: "5de33fe6-690a-4612-af66-ed99d872cac0",
    techProperties: "29080e48-7d0f-4f6b-847b-174aa5f93339",
    computers: "bcbe56ab-9659-4fa1-93bd-84bdefe0dc28",
    socialNetworks: "b94ab639-0a4b-4fd8-b62f-6047daeeb10e",
  },
  step9: {
    home: "291ddd12-477a-474d-8eb1-d004b80c1867",
    homeOwnership: "5beab5bf-4970-4719-8139-5be81c056263",
    land: "8cf0436a-a4ff-4123-b263-cdff00a9ba79",
    landOwnership: "e6be20b8-0044-4ab0-893e-c1b32c5c0e17",
  },
  step10: {
    familyGroup: "a24d9ec3-315f-4257-a002-c59016a4bfa4",
    familyGroupPosition: "45cbdb3c-fb64-4541-91e4-4b66fb79680e",
  },
  step11: {
    hasMate: "048b53eb-2aec-4102-a5c2-9f9bfc4cb1bc",
    mateDateOfBirth: "4dd6c5a2-0d1a-48e7-9367-caccb4d433b0",
    mateGender: "0900533b-3300-4abd-80ae-c029b957a837",
    areTogether: "8640d4c9-5e00-48ea-9b77-e60f189294ad",
    mateOccupation: "1ed15660-5fa7-4975-b054-204104074013",
    isSameOccupation: "17ab617f-254e-40d6-bbd0-398cda0aaa83",
    mateProfession: "0c68d234-51c7-4d67-beac-e611c39b1f0f",
    educationLevel: "c71df2e0-2626-401a-900e-7621c3c62d71",
    isCurrentlyStudying: "e97a734e-019b-4fb4-9669-4766f362c842",
    isContributor: "e1992fc7-0996-4572-b225-1e436af6ef91",
    isDependant: "cba0fccb-86f9-4a0d-8227-423c5e69a8fb",
    hasDisability: "e75d592c-7fbf-480c-9735-afee5ec94cc5",
    disability: "1c017b9a-17f8-4c1d-aedc-586a5288e8e2",
  },
  step12: {
    hasChildren: "1768c167-565d-419b-83ab-62612d3b4f00",
    numberOfChildren: "60e170e1-f9d8-484f-82c4-d765f22e3945",
    childrenRegistered: "ce5b96f7-435f-4746-aa2d-92de4ec35dfb",
    template: "233515b4-32d5-4e7e-9856-9a409c62c5c8",
  },
  step13: {
    numberOfPersons: "3064cfb9-419d-4ca7-959c-9d78f0abfd7d",
    template: "fac3345f-54ea-4dab-afb5-55159e4c61d0",
  },
  step14: {
    educationLevel: "1f4c8ff7-6a59-4b8f-8298-2a975edf5d50",
    degreeName: "c3b23fe2-4808-4f84-9b17-1837c90b82bc",
    isStudying: "e96aab53-5980-4cc4-af32-65c070184c40",
    careerName: "08d94ab1-13c9-4c20-a87c-381247b48bfc",
    careerModality: "477a2e05-a086-49f1-a895-28fbc9271cf2",
    studyDays: "9e0a5e09-81b2-44c5-b467-4b3ff58c7330",
    studySchedule: "8ba14abf-8c84-49b3-b989-b4a579f660f2",
  },
  step15: {
    isOtherLanguage: "8a15c719-7004-4e11-997b-73afc432ad6c",
    languageList: "ae3b6cab-536c-4d56-998b-0a265d823544",
    languageLevel: "3deadf42-39fc-47f6-9c79-8df23211f0e4",
    computingKnowledge: "5c6b75f2-bd46-49ab-ac9e-413e70b965cc",
    knowledgeRanking: "4f3940bc-82dc-4edf-b7ec-2b82f898ef2d",
  },
  step16: {
    additionalIncomes: "e14a98fc-cddc-48a3-9d29-d55846af64d2",
    incomesType: "801fb589-7391-4084-9d4d-50f852e1609e",
    incomesAverage: "260f482c-b15a-411b-8e55-cb6ac3d06a6d",
    incomesDestination: "57841d4d-bd5b-466f-90e5-6913e0c2714b",
    bankingProducts: "bf88da6a-ef83-4371-806a-3a5ca7d718b0",
    isSaveMoney: "18ebea9b-3179-46f3-b2b6-1959d2d795b6",
    saveAverage: "d3ab53c9-b5e4-4470-b172-7d852d4889c6",
  },
  step17: {
    policies: "bc849fc5-5d73-420d-ac4a-3f3a4fd10f70",
    hasPCS: "79fb4ce2-10f3-4b69-b8c0-ee0b385d2d04",
    pcsNames: "e6ef164a-af9d-45d8-9c42-eaa3c0816a55",
  },
  step18: {
    buyingPlace: "0e3baf87-96bf-44d2-aa8f-b446ad585bda",
    buyingFrequency: "c846e017-29ee-4391-b925-8515298abdd7",
    foodConsumed: "0de0fe22-95ce-4d0e-9567-61737a4ee156",
    isFoodGrown: "01d02f94-9a66-45b1-9866-914749ab3e2e",
    watterAvailability: "8b821292-0b15-4dfb-8d7d-36d91408b925",
    completedFood: "b890fe08-c33b-4502-9a01-08e29df6c843",
  },
  step19: {
    hasPersonalProject: "178d275f-8106-4867-945b-c4dec913bff8",
    projectType: "21ade98c-239d-4bfa-afd4-c4bdc8eadbe9",
    projectRequeriments: "a1c2656e-7676-4b1e-a5d0-7ddfc6785a66",
    needsOrConcerns: "9a45c51b-721e-47a4-9aac-25d94530c309",
  },
  step20: {
    hoobies: "65c1e87b-7ad6-45ed-88af-a9bbfd38b50a",
    desiredHobbies: "9c7bd001-527e-44b8-a94e-b896bbe1a522",
    needs: "c3bcd6e5-e4ab-4cb4-9ea0-7a34f6c306b8",
    hasCommunityActivities: "45a55ad7-abcd-499b-aa39-ee9b66c6850c",
    communityActivities: "17ef916e-74b0-40e1-adb5-99f2c35aead7",
  },
};

// gettin only the active contract.
const getActiveContract = (person?: SurveyPerson | null) => {
  if (person?.contracts?.length) {
    const activeContract = person.contracts.find((obj) => obj.estado === "ACTIVO");
    return activeContract;
  }
};

export const getInitialValues = (step: number, answers: Answers[], person?: SurveyPerson | null) => {
  const getValues = getValuesFromAnswers(answers);
  const getValuesForArray = getValuesFromArray(answers);
  //const getValuesForTemplate = getValuesFromTemplate(answers);
  switch (step) {
    case 1:
      return {
        identificationType: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step1.identificationType,
          value: person?.identificationTypeId || "",
        },
        identificationNumber: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step1.documentNumber,
          value: person?.identificationNumber || "",
        },
        name: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step1.name,
          value: person?.personNames || "",
        },
        lastName: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step1.lastName,
          value: person?.personLastName || "",
        },
      };
    case 2:
      return {
        gender: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.gender,
          value: getValues(questionIds.step2.gender),
        },
        birthCountry: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.birthCountry,
          value: getValues(questionIds.step2.birthCountry),
        },
        birthState: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.birthState,
          value: getValues(questionIds.step2.birthState),
        },
        birthCity: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.birthCity,
          value: getValues(questionIds.step2.birthCity),
        },
        birthDate: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.birthDate,
          value: getValues(questionIds.step2.birthDate),
        },
        maritalStatus: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.maritalStatus,
          value: getValues(questionIds.step2.maritalStatus),
        },
        socialGroups: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.socialGroups,
          value: getValues(questionIds.step2.socialGroups),
        },
        sisben: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.sisben,
          value: getValues(questionIds.step2.sisben),
        },
        sisbenCategory: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step2.sisbenCategory,
          value: getValues(questionIds.step2.sisbenCategory),
        },
      };
    case 3:
      return {
        branch: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.branch,
          value: getActiveContract(person)?.businessCode?.toUpperCase(),
        },
        jobTitle: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.jobTitle,
          value: getActiveContract(person)?.jobId?.toUpperCase(),
        },
        compensationCompany: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.compensationCompany,
          value: person?.ccfId?.toUpperCase() || "",
        },
        jubilation: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.jubilation,
          value: person?.afpId?.toUpperCase() || "",
        },
        layoff: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.layoff,
          value: person?.fcesId?.toUpperCase() || "",
        },
        eps: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step3.eps,
          value: person?.epsId?.toUpperCase() || "",
        },
      };
    case 4:
      return {
        cellPhoneNumber: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.cellPhoneNumber,
          value: getValues(questionIds.step4.cellPhoneNumber),
        },
        cellPhoneCompany: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.cellPhoneCompany,
          value: getValues(questionIds.step4.cellPhoneCompany),
        },
        email: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.email,
          value: getValues(questionIds.step4.email),
        },
        hasCellPhone: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.hasCellPhone,
          value: getValues(questionIds.step4.hasCellPhone),
        },
        emergencyContactName: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.emergencyContactName,
          value: getValues(questionIds.step4.emergencyContactName),
        },
        relationshipEmergencyContact: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.relationshipEmergencyContact,
          value: getValues(questionIds.step4.relationshipEmergencyContact),
        },
        emergencyContactPhoneNumber: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step4.emergencyContactPhoneNumber,
          value: getValues(questionIds.step4.emergencyContactPhoneNumber),
        },
      };
    case 5:
      return {
        transportation: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step5.transportation,
          value: getValues(questionIds.step5.transportation),
        },
        transportationTime: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step5.transportationTime,
          value: getValues(questionIds.step5.transportationTime),
        },
        emergencyCorps: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step5.emergencyCorps,
          value: getValues(questionIds.step5.emergencyCorps),
        },
        hasEmploymentFund: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step5.hasEmploymentFund,
          value: getValues(questionIds.step5.hasEmploymentFund),
        },
      };
    case 6:
      return {
        placeCountry: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.placeCountry,
          value: getValues(questionIds.step6.placeCountry),
        },
        placeState: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.placeState,
          value: getValues(questionIds.step6.placeState),
        },
        placeCity: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.placeCity,
          value: getValues(questionIds.step6.placeCity),
        },
        neighborhood: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.neighborhood,
          value: getValues(questionIds.step6.neighborhood),
        },
        address: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.address,
          value: getValues(questionIds.step6.address),
        },
        dwellTime: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.dwellTime,
          value: getValues(questionIds.step6.dwellTime),
        },
        houseLocation: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.houseLocation,
          value: getValues(questionIds.step6.houseLocation),
        },
        category: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.category,
          value: getValues(questionIds.step6.category),
        },
        houseType: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.houseType,
          value: getValues(questionIds.step6.houseType),
        },
        houseTenure: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step6.houseTenure,
          value: getValues(questionIds.step6.houseTenure),
        },
      };
    case 7:
      return {
        houseContition: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step7.houseContition,
          value: getValues(questionIds.step7.houseContition),
        },
        houseStatus: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step7.houseStatus,
          value: getValues(questionIds.step7.houseStatus),
        },
        rooms: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step7.rooms,
          value: getValues(questionIds.step7.rooms),
        },
        houseServices: getValuesForArray(questionIds.step7.houseServices) ?? [],
      };
    case 8:
      return {
        properties: getValuesForArray(questionIds.step8.properties) ?? [],
        techProperties: getValuesForArray(questionIds.step8.techProperties) ?? [],
        computers: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step8.computers,
          value: getValues(questionIds.step8.computers),
        },
        socialNetworks: getValuesForArray(questionIds.step8.socialNetworks) ?? [],
      };
    case 9:
      return {
        home: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step9.home,
          value: getValues(questionIds.step9.home),
        },
        homeOwnership: getValuesForArray(questionIds.step9.homeOwnership) ?? [],
        land: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step9.land,
          value: getValues(questionIds.step9.land),
        },
        landOwnership: getValuesForArray(questionIds.step9.landOwnership) ?? [],
      };
    case 10:
      return {
        familyGroup: getValuesForArray(questionIds.step10.familyGroup) ?? [],
        familyGroupPosition: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step10.familyGroupPosition,
          value: getValues(questionIds.step10.familyGroupPosition),
        },
      };
    case 11:
      return {
        hasMate: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.hasMate,
          value: getValues(questionIds.step11.hasMate),
        },
        mateDateOfBirth: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.mateDateOfBirth,
          value: getValues(questionIds.step11.mateDateOfBirth),
        },
        mateGender: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.mateGender,
          value: getValues(questionIds.step11.mateGender),
        },
        areTogether: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.areTogether,
          value: getValues(questionIds.step11.areTogether),
        },
        mateOccupation: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.mateOccupation,
          value: getValues(questionIds.step11.mateOccupation),
        },
        isSameOccupation: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.isSameOccupation,
          value: getValues(questionIds.step11.isSameOccupation),
        },
        mateProfession: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.mateProfession,
          value: getValues(questionIds.step11.mateProfession),
        },
        educationLevel: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.educationLevel,
          value: getValues(questionIds.step11.educationLevel),
        },
        isCurrentlyStudying: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.isCurrentlyStudying,
          value: getValues(questionIds.step11.isCurrentlyStudying),
        },
        isContributor: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.isContributor,
          value: getValues(questionIds.step11.isContributor),
        },
        isDependant: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.isDependant,
          value: getValues(questionIds.step11.isDependant),
        },
        hasDisability: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.hasDisability,
          value: getValues(questionIds.step11.hasDisability),
        },
        disability: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step11.disability,
          value: getValues(questionIds.step11.disability),
        },
      };
    case 12:
      return {
        hasChildren: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step12.hasChildren,
          value: getValues(questionIds.step12.hasChildren),
        },
        numberOfChildren: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step12.numberOfChildren,
          value: getValues(questionIds.step12.numberOfChildren),
        },
        childrenRegistered: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step12.childrenRegistered,
          value: getValues(questionIds.step12.childrenRegistered),
        },
        template: [],
      };
    case 13:
      return {
        numberOfPersons: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step13.numberOfPersons,
          value: getValues(questionIds.step13.numberOfPersons) || 0,
        },
        template: [],
      };
    case 14:
      return {
        educationLevel: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.educationLevel,
          value: getValues(questionIds.step14.educationLevel),
        },
        degreeName: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.degreeName,
          value: getValues(questionIds.step14.degreeName),
        },
        isStudying: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.isStudying,
          value: getValues(questionIds.step14.isStudying),
        },
        careerName: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.careerName,
          value: getValues(questionIds.step14.careerName),
        },
        careerModality: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.careerModality,
          value: getValues(questionIds.step14.careerModality),
        },
        studyDays: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.studyDays,
          value: getValues(questionIds.step14.studyDays),
        },
        studySchedule: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step14.studySchedule,
          value: getValues(questionIds.step14.studySchedule),
        },
      };
    case 15:
      return {
        isOtherLanguage: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step15.isOtherLanguage,
          value: getValues(questionIds.step15.isOtherLanguage),
        },
        languageList: getValuesForArray(questionIds.step15.languageList) ?? [],
        computingKnowledge: getValuesForArray(questionIds.step15.computingKnowledge) ?? [],
        knowledgeRanking: getValuesForArray(questionIds.step15.knowledgeRanking) ?? [],
      };
    case 16:
      return {
        additionalIncomes: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step16.additionalIncomes,
          value: getValues(questionIds.step16.additionalIncomes),
        },
        incomesType: getValuesForArray(questionIds.step16.incomesType) ?? [],
        incomesAverage: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step16.incomesAverage,
          value: getValues(questionIds.step16.incomesAverage),
        },
        incomesDestination: getValuesForArray(questionIds.step16.incomesDestination) ?? [],
        bankingProducts: getValuesForArray(questionIds.step16.bankingProducts) ?? [],
        isSaveMoney: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step16.isSaveMoney,
          value: getValues(questionIds.step16.isSaveMoney),
        },
        saveAverage: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step16.saveAverage,
          value: getValues(questionIds.step16.saveAverage),
        },
      };
    case 17:
      return {
        policies: getValuesForArray(questionIds.step17.policies) ?? [],
        hasPCS: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step17.hasPCS,
          value: getValues(questionIds.step17.hasPCS),
        },
        pcsNames: getValuesForArray(questionIds.step17.pcsNames) ?? [],
      };
    case 18:
      return {
        buyingPlace: getValuesForArray(questionIds.step18.buyingPlace) ?? [],
        buyingFrequency: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step18.buyingFrequency,
          value: getValues(questionIds.step18.buyingFrequency),
        },
        foodConsumed: getValuesForArray(questionIds.step18.foodConsumed) ?? [],
        isFoodGrown: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step18.isFoodGrown,
          value: getValues(questionIds.step18.isFoodGrown),
        },
        watterAvailability: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step18.watterAvailability,
          value: getValues(questionIds.step18.watterAvailability),
        },
        completedFood: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step18.completedFood,
          value: getValues(questionIds.step18.completedFood),
        },
      };
    case 19:
      return {
        hasPersonalProject: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step19.hasPersonalProject,
          value: getValues(questionIds.step19.hasPersonalProject),
        },
        projectType: getValuesForArray(questionIds.step19.projectType) ?? [],
        projectRequeriments: getValuesForArray(questionIds.step19.projectRequeriments) ?? [],
        needsOrConcerns: getValuesForArray(questionIds.step19.needsOrConcerns) ?? [],
      };
    case 20:
      return {
        hoobies: getValuesForArray(questionIds.step20.hoobies) ?? [],
        desiredHobbies: getValuesForArray(questionIds.step20.desiredHobbies) ?? [],
        needs: getValuesForArray(questionIds.step20.needs) ?? [],
        hasCommunityActivities: {
          updatedBy: "",
          subSectionId: 0,
          userCreation: "",
          questionID: questionIds.step20.hasCommunityActivities,
          value: getValues(questionIds.step20.hasCommunityActivities),
        },
        communityActivities: getValuesForArray(questionIds.step20.communityActivities) ?? [],
      };
    default:
      return {};
  }
};

const mergeItems = (array: any) =>
  array.reduce(function (o: any, cur: any) {
    // Get the index of the key-value pair.
    const occurs = o.reduce(function (n: any, item: any, i: any) {
      return item.questionID === cur.questionID ? i : n;
    }, -1);

    // If the questionID is found,
    if (occurs >= 0) {
      // append the current value to its list of values.
      o[occurs].value = [o[occurs].value, cur.value];

      // Otherwise,
    } else {
      const obj = {
        ...cur,
        value: cur.value,
      };
      o = o.concat([obj]);
    }

    return o;
  }, []);

/* A function that takes an array of answers and returns a function that takes a questionId and returns
the value of the answer. */
const getValuesFromAnswers = (answers: Answers[]) => (questionId: string) =>
  answers.find((answer) => answer.questionID === questionId)?.value || "";

const getValuesFromArray = (answers: Answers[]) => (questionId: string) =>
  answers.filter((answer) => answer.questionID === questionId) ?? [];

const getValuesFromTemplate = (answers: Answers[]) => (questionIds: any) => {
  const template = [];
  const answersByQuestionId = answers.filter((answer) => questionIds.includes(answer.questionID));
  const subSections =
    uniqWith(
      answersByQuestionId.map((answer) => answer.subSectionId),
      isEqual
    ) ?? [];

  for (let index = 0; index < subSections?.length; index++) {
    const answersFiltered = answersByQuestionId.filter((answers: any) => answers?.subSectionId === index);
    const answersMerged = mergeItems(answersFiltered);

    const result = answersMerged.map((answer: any) => ({ [answer?.questionID]: answer?.value }));
    const resultReduced = result
      .flatMap((item: any) => Object.entries(item))
      .reduce((acc: any, [key, value]: any) => ({ ...acc, [key]: value }), {});
    template.push(resultReduced);
  }

  return template ?? [];
};
